import React from 'react'
import '../Footer/Footer.css'

const Footer = () => {
  return (
    <div className='Footer'>
      <div>
        <h4>EDYODA</h4>
        <div>
         <p>About Us</p>
         <p>Careers</p>
         <p>Contact Us</p>
         <p>Terms of Use</p>
         <p>Privacy Policy</p>
         </div>


      </div>



      <div>
        <h4>RESOURCES</h4>
          <div>
         <p>Learning Paths</p>
         <p>Courses</p>
         <p>Learning Videos</p>
         <p>EdYoda Stories</p>
         <p>University</p>
         </div>
      </div>


      <div>
        <h4>FOR ENTERPRISES</h4>
         <p>Train Your Employees</p>

         <h4>QUICK LINKS</h4>
         <p>Learn and Earn</p>
         <p>Become a Learning-Enabler</p>
         <p>Tips for Learning-Enabler</p>
         <p>Request New Topic</p>
         <p>Certification</p>
         <p>Affiliate Progam</p>

      </div>



      <div>
        <h4>CONNECT</h4>
          <div>
         <p>1st Floor,</p>
         <p>Gopalan Millennium Tower,</p>
         <p>ITPL Main Road, Brookefield,</p>
         <p>Bengaluru, Karnataka-560037,</p>
         <p>India</p>
         

         <p><i class="fa fa-envelope-o" aria-hidden="true"></i> hello@edyoda.com</p>
         <p>Learning Videos</p>
         <p><i class="fa fa-map-marker" aria-hidden="true"></i>           <i class="fa fa-twitter" aria-hidden="true"></i>           <i class="fa fa-facebook-square" aria-hidden="true"></i>           <i class="fa fa-google-plus" aria-hidden="true"></i> </p>
         <p>© 2022</p>
         <p>zekeLabs Technologies Private Limited</p>
         </div>
      </div>






    </div>
  )
}

export default Footer
